// extracted by mini-css-extract-plugin
module.exports = {"sbQuestion":"styles_sbQuestion__2JjtH","actionsColumn":"styles_actionsColumn__3Ca5I"};